import Constants from '@/js/utils/constants';
import HttpUtils from '@/js/utils/http.utils';

let ProjectAPIS = {

	urls: {
		'jobs': Constants.BASE_URL + '/jobs',
		'jobs_group': Constants.BASE_URL + '/jobs/group',
		'job_user': Constants.BASE_URL + '/job/user',
		'user_center': Constants.BASE_URL + '/user-center',
		'collection_directions': Constants.BASE_URL + '/collection-directions',
		'collection_elements': Constants.BASE_URL + '/collection-elements',
		'collection_targets': Constants.BASE_URL + '/collection-targets',
		'collection_expense_departments': Constants.BASE_URL + '/collection-expense-departments',
        'scene_elements': Constants.BASE_URL + '/scene-elements',
		'hubble_detail': Constants.BASE_URL_V2 + '/data-sets',
	},

	getHubble(projectId) {
		return HttpUtils.get(this.urls.hubble_detail + '/' + projectId + '/revision');
	},

	getJobDetail(projectId) {
		return HttpUtils.get(this.urls.jobs + '/' + projectId, {});
	},

	getJobs(params) {
		return HttpUtils.get(this.urls.jobs, params);
	},

	postJobs(params) {
		return HttpUtils.post(this.urls.jobs, params);
	},

	putJobs(projectId, params) {
		return HttpUtils.put(this.urls.jobs + "/" + projectId, params);
	},

	getJobUser(projectId) {
		return HttpUtils.get(this.urls.job_user, {
			job_id: projectId
		});
	},

	patchJobUser(params) {
		return HttpUtils.patch(this.urls.job_user, params);
	},

	postJobUser(params) {
		return HttpUtils.post(this.urls.job_user, params);
	},

	getUsers(query) {
		return HttpUtils.get(this.urls.user_center + "/" + query, {});
	},

	getProjectManagerUsers(query, params) {
		return HttpUtils.get(this.urls.user_center + "/" + query, params);
	},
	//---重构新接口 12.07
	getResearchDirections(params) {
		return HttpUtils.get(this.urls.collection_directions, params);
	},

	getResearchDirectionCollectionElements(researchDirectionId, params) {
		return HttpUtils.get(this.urls.collection_directions + "/" + researchDirectionId + "/" + "elements", params);
	},

	getCollectionElementItems(elementId, params) {
		return HttpUtils.get(this.urls.collection_elements + "/" + elementId + "/" + "items", params);
	},

	getCollectionTargets(params) {
		return HttpUtils.get(this.urls.collection_targets, params);
	},

	getCollectionTargetItems(targetId, params) {
		return HttpUtils.get(this.urls.collection_targets + "/" + targetId + "/" + "items", params);
	},

	getCollectionExpenseDepartments(params) {
		return HttpUtils.get(this.urls.collection_expense_departments, params);
	},

	getSceneElements(params) {
		return HttpUtils.get(this.urls.scene_elements, params);
	},
};

export default ProjectAPIS



// WEBPACK FOOTER //
// ./src/js/modules/project/api/project-apis.js